import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getAccessTokenforResource } from 'owa-tokenprovider';

const ENTERPRISE_NUDGE_TOKEN_RESOURCE = 'https://outlook.office.com/FocusedInboxB2';

export default async function getCustomHeadersForNudgeRequest() {
    const token = await getAccessTokenForNudge();
    const headers = new Headers();

    if (token) {
        headers['authorization'] = `Bearer ${token}`;
    }

    return headers;
}

async function getAccessTokenForNudge(): Promise<string> {
    if (!isConsumer()) {
        return getAccessTokenforResource(ENTERPRISE_NUDGE_TOKEN_RESOURCE);
    }

    return null;
}
